module.exports = __webpack_public_path__ + "static/media/thunderstorm-moon.cedc3bd6.svg";